import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination } from "swiper/core";



SwiperCore.use([Navigation, Pagination]);

export const Slider = {
  init() {
    const swiper = new Swiper(".swiper-container", {
      // Optional parameters
      direction: "horizontal",
      // autoHeight: true,
      allowTouchMove: true,
      slidesPerView: 4,
      spaceBetween: 20,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      //pagination
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    setTimeout(() => {
      swiper.autoHeight =  true;

    }, 1000)

  },

  
};
